import Testing from "./Testing";

export const TESTING_URL = "legallyknowledgetest";

export default Testing;